import moment from "moment";

export const VIEW_STATUS = {
    SecurityCheck: "SecurityCheck",
    LoadingData: "LoadingData",
    Loading: "Loading",
    Loaded: "Loaded",
    Error: "Error"
}

export const VIEW_MODE = {
    WEEK: "week",
    MONTH: "month"
}

const ptoColor = "#090";
const sickColor = "#EB0";
const holColor = "#7aF";
const miscColor = "#999";
const ftoColor = "#1D999D";
const ftoSickColor = "#C41DC8";
const vaca1Color = "#090";
const vaca2Color = "#1D999D";

const ptoCode = "PTO";
const sickCode = "SICK";
const holCode = "HOL";
const dfholCode = "DFHOL";
const miscCode = "MISC";
const ftoCode = "FTO";
const ftoSickCode = "FTOSICK";
const vaca1Code = "VACA1";
const vaca2Code = "VACA2";

const ptoText = "PTO";
const sickText = "Sick Leave";
const holText = "Holiday";
const miscText = "Misc. Requests";
const ftoText = "FTO";
const ftoSickText = "SICK/FTO";
const vaca1Text = "VAC-E";
const vaca2Text = "VAC-C";


export const PTO_LEGEND_ARRAY = [
    { color: ptoColor, code: ptoCode, text: ptoText, },
    { color: sickColor, code: sickCode, text: sickText, },
    { color: holColor, code: holCode, text: holText, },    
    { color: miscColor, code: miscCode, text: miscText, },
    { color: ftoColor, code: ftoCode, text: ftoText, },
    { color: ftoSickColor, code: ftoSickCode, text: ftoSickText, },
    { color: vaca1Color, code: vaca1Code, text: vaca1Text, },
    { color: vaca2Color, code: vaca2Code, text: vaca2Text, }
]

export const PTO_LEGEND_COLOR_MAP = {
    [ptoCode]: { color: ptoColor, text: ptoText, title: "PTO - Personal/Vacation Day" },
    [sickCode]: { color: sickColor, text: sickText, title: "Sick Leave - Personal Illness" },
    [holCode]: { color: holColor, text: holText, title: "Public Holiday" },    
    [miscCode]: { color: miscColor, text: miscText, title: "Misc. Request" },
    [ftoCode]: { color: ftoColor, text: ftoText, title: "FTO - Personal Time" },
    [ftoSickCode]: { color: ftoSickColor, text: ftoSickText, title: "Sick/FTO - Sick Leave" },
    [vaca1Code]: { color: vaca1Color, text: vaca1Text, title: "Vacation - Earned Leave" },
    [vaca2Code]: { color: vaca2Color, text: vaca2Text, title: "Vacation - Casual Leave" }
}

export const PTO_STATUS_MAP = {
    Requested: { Icon: "fa fa-minus-circle orange", Label: "Requested", Description: "Awaiting Approval"},
    Pending: { Icon: "fa fa-minus-circle yellow", Label: "Pending", Description: "HR Consulation"},
    Approved: { Icon: "fa fa-check-circle green", Label: "Approved", Description: "Approved & Awaiting Payroll Processing"},
    Processed: { Icon: "fa fa-check-circle blue", Label: "Processed", Description: "Payroll Processed"},
    Cancelled: { Icon: "fa fa-times-circle grey", Label: "Cancelled", Description: "Cancelled"},
    Denied: { Icon: "fa fa-times-circle red", Label: "Denied", Description: "Denied"}
}

export const PTO_STATUS = {
    Requested: "Requested",
    Pending: "Pending",
    Approved: "Approved",
    Processed: "Processed",
    Cancelled: "Cancelled",
    Denied: "Denied",
}

export function dateKey(m) {
    return moment(m).format("YYYYMMDD");
}

export function itemClass(item) {
    return item.pto ?
        `ci_PTO_${item.pto.ptoId}` :
        `ci_EXPENSE_${item.expenses[0].expenseId}`;
}